import type { IntentSignalDomainsRowDto } from "../IntentSignalRowDto";

const isIntentSignalDomainsRowDto = (row: unknown): row is IntentSignalDomainsRowDto => {
    return "domainsCount" in (row as IntentSignalDomainsRowDto) && "topic" in (row as IntentSignalDomainsRowDto);
};

export default isIntentSignalDomainsRowDto;
